import { useBundle } from "@amzn/react-arb-tools";
import fallbackTranslations from "./translations/translation.json";
import { BUNDLE_NAME } from "./constants";

const getFallback = (key: string): string => {
    const fallbackMessage = (fallbackTranslations.und[BUNDLE_NAME] as {[key: string]: string})[key];
    return fallbackMessage ?? key;
};

const useTranslation = () => {
    const [arbBundle, isArbBundleLoading] = useBundle(BUNDLE_NAME);

    const t = (key: string): string => {
        try {
            if (isArbBundleLoading) return getFallback(key);
            return arbBundle?.getMessage(key) ?? getFallback(key);
        } catch {
            return getFallback(key);
        }
    };

    return t;
};

export { useTranslation };
